import React from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import "../assetsv2/style.scss"
import Link from "@bappweb/link"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue } from "@smpu-web/utils/utils"

const LandingHeader = () => {
  let size = useDeviceSize()
  size = size === undefined ? Sizes.md : size
  const isHigherThanMd = size > Sizes.md ? true : false

  const sessionData = useAppSelector((state) => state.sessionData.response)
  return (
    <Block className="banner image-top">
      <Block className="container position-relative">
        <Link href="https://www.akbank.com/" className="logo">
          <Image className="logo" path={"./img/pos-basvuru/logo.svg"} />
        </Link>
        <Block type="section" className="section general-features" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "PosBasvuru.Landing.Top") }} />
        {isHigherThanMd &&
          <picture>
            <source
              data-srcset="./img/pos-basvuru/pos_cihazi.png, ./img/pos-basvuru/pos_cihazi.png@2x.png 2x"
              data-src="./img/pos-basvuru/transparent.png"
            />
            <Image
              className="lazyload img-fluid banner-img"
              path={"./img/pos-basvuru/pos_cihazi.png"}
            />
          </picture>
        }
      </Block>
    </Block>
  )
}

export default LandingHeader
